module.exports = __webpack_public_path__ + "img/wh.08073a96.png";